export const tr = {
    advertisement: 'Reklam',
    'agency-client-help-link': 'Yandex Müşteri Hizmetleri',
    'common-help-link': 'Destek Ekibi',
    'self-agency-help-link': 'Reklam ajansları ile çalışma departmanı'
};
